import { MutationTree } from "vuex"
import { WidgetState } from "@/apps/StudentExchangePartnerWidget/models/store-viewmodel"
import { ILabels, ILanguage } from "@/apps/StudentExchangePartnerWidget/models/config-viewmodel";

export default <MutationTree<WidgetState>>{
    loading(state, loading: boolean) {
        state.loading = loading
    },
    labels(state, labels: ILabels) {
        state.labels = labels
    },
    signUp(state, signUp: boolean) {
        state.signup = signUp
    },
    insurance(state, insurance: boolean) {
        state.insurance = insurance
    },
    privacy(state, privacy: boolean) {
        state.privacy = privacy
    },
    programId(state, programId: number) {
        state.programId = programId
    },
    redirectUrl(state, redirectUrl: string) {
        state.redirectUrl = redirectUrl
    },
    language(state, language: ILanguage) {
        state.language = language
    },
    errorMessage(state, errorMessage: string) {
        state.errorMessage = errorMessage
    },
    studyName(state, studyName: string) {
        state.studyName = studyName
    }
}
